import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import menuApi from "../../../api/menu/menuApi";
import Loading from "../../../Util/Loading";

const Category = () => {
  const businessState = useSelector((state) => state?.user || {});

  console.log({ businessState });
  const user = businessState?.user;
  const businessId = user?._id;

  console.log({ businessId });
  const [categories, setCategories] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newCategory, setNewCategory] = useState({ name: "", image: "" });
  const [isEditing, setIsEditing] = useState(false); // To track if editing or creating
  const navigate = useNavigate();

  const getMenuCategoryByOperator = async () => {
    try {
      const response = await menuApi.getMenuCategoryByOperator(businessId);
      setCategories(response.data.category);
    } catch (error) {
      console.error("Failed to fetch menu category:", error);
    }
  };

  useEffect(() => {
    if (businessId) {
      getMenuCategoryByOperator();
    }
  }, [businessId]);

  const handleCategoryClick = (categoryId) => {
    console.log("categoryId", categoryId);
    navigate(`/apps/menu/menuItem/${categoryId}`);
  };

  const handleCreateCategory = async () => {
    try {
      const categoryData = { ...newCategory, operator: businessId };
      const response = await menuApi.createCategoryMenu(categoryData);
      setCategories([...categories, response.data.category]);
      setIsModalOpen(false);
    } catch (error) {
      console.error("Failed to create category:", error);
    }
  };

  const handleEditCategory = async () => {
    try {
      const categoryData = { ...newCategory, operator: businessId };
      const response = await menuApi.updateCategoryMenu(categoryData);
      setCategories(
        categories.map((category) =>
          category._id === newCategory._id ? response.data.category : category
        )
      );
      setIsModalOpen(false);
    } catch (error) {
      console.error("Failed to edit category:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewCategory((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDeleteCategory = async (categoryId) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this category?"
      );
      if (!confirmDelete) return;
      await menuApi.deleteCategoryMenu(categoryId);
      setCategories(
        categories.filter((category) => category._id !== categoryId)
      );
    } catch (error) {
      console.error("Failed to delete category:", error);
    }
  };

  const handleEditClick = (categoryId) => {
    const category = categories.find((category) => category._id === categoryId);
    setNewCategory(category);
    setIsEditing(true);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsEditing(false); // Reset the editing flag
  };

  return (
    <div className="container mx-auto p-6">
      <div className="text-3xl font-bold mb-6 text-center text-gray-800">
        List Category
      </div>

      {/* Create Category Button */}
      <div className="mb-8 text-right">
        <button
          onClick={() => {
            setIsEditing(false);
            setNewCategory({ name: "", image: "" }); // Reset form for create
            setIsModalOpen(true);
          }}
          className="p-3 bg-red-600 text-white rounded-md hover:bg-red-700 transition duration-300 shadow-md"
        >
          Create
        </button>
      </div>

      {/* Loading Indicator */}
      {categories === null ? (
        <div className="flex justify-center">
          <Loading />
        </div>
      ) : (
        <div className="overflow-x-auto shadow-lg rounded-lg bg-white mt-20">
          <table className="min-w-full table-auto">
            <thead>
              <tr className="bg-gray-200 border-b">
                <th className="p-3 text-left">Name</th>
                <th className="p-3 text-left">Image</th>
                <th className="p-3 text-left">Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => (
                <tr
                  key={category._id}
                  className="border-b hover:bg-gray-50 cursor-pointer"
                  onClick={() => handleCategoryClick(category._id)}
                >
                  <td className="p-3">{category.name}</td>
                  <td className="p-3">
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-64 h-64 object-cover rounded-md"
                    />
                  </td>
                  <td className="p-3">
                    <button
                      className="p-2 text-blue-600 hover:text-blue-800"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditClick(category._id);
                      }}
                    >
                      <FaEdit size={20} />
                    </button>
                    <button
                      className="p-2 text-red-600 hover:text-red-800"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteCategory(category._id);
                      }}
                    >
                      <FaTrash size={20} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal for Creating or Editing Category */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-1/3">
            <h3 className="text-2xl mb-6">
              {isEditing ? "Edit Category" : "Create New Category"}
            </h3>

            <form>
              <div className="mb-4">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={newCategory.name}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-md"
                  placeholder="Enter category name"
                />
              </div>

              <div className="mb-4">
                <label
                  htmlFor="image"
                  className="block text-sm font-medium text-gray-700"
                >
                  Image
                </label>
                <input
                  type="text"
                  id="image"
                  name="image"
                  value={newCategory.image}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-md"
                  placeholder="Enter image URL"
                />
              </div>

              <div className="text-right flex gap-2">
                <button
                  type="button"
                  onClick={
                    isEditing ? handleEditCategory : handleCreateCategory
                  }
                  className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition duration-300"
                >
                  {isEditing ? "Save Changes" : "Create Category"}
                </button>
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="ml-4 px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition duration-300"
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Category;
